import Vue from 'vue';

type ShortcutFunctions = { [key: string | number]: () => void };
export default abstract class ShortcutKeyComponent extends Vue {
    protected readonly ctrlShortcuts?: ShortcutFunctions;
    protected readonly altShortcuts?: ShortcutFunctions;

    private readonly runningShortcuts: Set<() => void> = new Set();
    readonly listener = async (ev: KeyboardEvent) => {
        if (ev.repeat) return;

        const pressedCtrl = isMac() ? ev.metaKey : ev.ctrlKey;
        const shortcuts = pressedCtrl
            ? this.ctrlShortcuts
            : ev.altKey
              ? this.altShortcuts
              : null;
        if (!shortcuts) return;

        const method = Object.entries(shortcuts)
            .filter(([key, _]) => key.toLowerCase() === ev.key.toLowerCase())
            .map(([_, func]) => func)[0];
        if (!method) return;

        console.log('Call ShortcutKey', method, ev);
        ev.preventDefault();
        ev.stopPropagation();
        if (this.runningShortcuts.has(method)) return;
        try {
            this.runningShortcuts.add(method);
            await method();
        } finally {
            this.runningShortcuts.delete(method);
        }
    };

    shortcutKeyLabel(key: string) {
        return `ショートカットキー: ${CTRL_KEY} + ${key}`;
    }

    created() {
        window.addEventListener('keydown', this.listener);
    }

    destroyed() {
        window.removeEventListener('keydown', this.listener);
    }
}

export function isMac() {
    return /macintosh/i.test(navigator.userAgent);
}

export const CTRL_KEY = isMac() ? '⌘' : 'Ctrl';

export function withCtrlKey(event: KeyboardEvent | MouseEvent) {
    return isMac() ? event.metaKey : event.ctrlKey;
}
